import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { CreateEditBatchComponent } from '../components/create-edit-batch/create-edit-batch.component';
import { MatDialog } from '@angular/material/dialog';
import { ProjectService } from '../services/project.service';
import { ConfirmationPopUpComponent } from '../ui-component-library/core/confirmation-pop-up/confirmation-pop-up.component';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BatchFormGuard implements CanDeactivate<CreateEditBatchComponent> {
  constructor(
    private dialog: MatDialog,
    private projectService: ProjectService
  ) {}
  canDeactivate(component: CreateEditBatchComponent): Observable<boolean> | boolean {
    if (component.skipDeactivateGuard) {
      // if we are saving the data and navigating to parent route,
      // route change guard must not trigger
      return true;
    }
    if (component.mode === 'create') {
      if (component.batchFormStep1.dirty || component.batchFormStep2.dirty) {
        return this.openConfirmDialog(component.mode);
      }
    } else if (component.mode === 'edit' && component.hasChanges()) {
      return this.openConfirmDialog(component.mode);
    }
    return true;
  }

  openConfirmDialog(mode: string): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationPopUpComponent, {
      data: {
        title: mode == 'edit' ? 'Cancel Edit' : 'Cancel Batch',
        message: 'Are you sure you want to cancel? All changes will be lost.',
        confirmText: 'Confirm',
        cancelText: 'Cancel',
        cssClass: 'confirmation-dialog',
      },
      autoFocus: false,
      disableClose: true,
    });

    return dialogRef.afterClosed().pipe(
      map((result) => {
        if (result) {
          // Perform cleanup only if user confirms
          this.projectService.clearExperimentForEdit();
          this.projectService.clearProjectForEdit();
          this.projectService.clearBatchForEdit();
          return true; // Allow navigation
        }
        return false; // Stay on the page
      })
    );
  }
}
